import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function ExcelExportDialog({ open = false, handleClose, excelExport }) {
  const { t } = useTranslation();
  const [kabel, setKabel] = useState(true);
  const [device, setDevice] = useState(true);

  return (
      <Dialog open={open} onClose={() => handleClose()} fullWidth maxWidth="md">
        <DialogTitle>{t("Excel Export starten")}</DialogTitle>

        <DialogContent dividers>
          <FormGroup>
            <Typography>{t("Was soll die Excel Datei enthalten?")}</Typography>
            <FormControlLabel control={<Checkbox checked={kabel} onChange={(e) => setKabel(e.target.checked)} />} label={t("Auswertung nach Kabel")} />
            <FormControlLabel control={<Checkbox checked={device} onChange={(e) => setDevice(e.target.checked)} />} label={t("Auswertung nach Gerät")} />
          </FormGroup>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={() => handleClose()}>
            {t("Abbrechen")}
          </Button>
          <Button variant="contained" onClick={() => excelExport(kabel, device)}>
            {t("Erstellen")}
          </Button>
        </DialogActions>
      </Dialog>
  );
}
